jQuery(document).ready(function($) {
	new WOW().init();

 /* ====================== REMOVE EMPTY P TAG ======================  */
    $('p').each(function() {
        var $this = $(this);
        if ($this.html().replace(/\s|&nbsp;/g, '').length == 0)
            $this.remove();
    });

/* ====================== SCROLL FUNCTIONS ======================  */

$(window).scroll(function() {
	var windowScroll = $(window).scrollTop();

	if (windowScroll > 0) {
		$(".header").addClass('scroll');
	} else {
		$(".header").removeClass('scroll');
	}

	var windowHeight = $(window).height();
	var translate3d = windowScroll / 5;

	if(windowScroll < windowHeight) {
		$(".masthead__bg").css('transform', 'translate3d(0px,'+ translate3d +'px, 0px)');
	}
});

/* ====================== CLICK FUNCSTIONS ======================  */
	$('.nav-trigger').click(function(){
		$('.header').toggleClass('nav-show');
		$('#menu-main-menu > li.menu-item-has-children').removeClass('open');
		$('.sub-menu').slideUp();
	});

	$('#menu-main-menu > li.menu-item-has-children').click(function(){
		$(this).toggleClass('open');
		$(this).find('.sub-menu').slideDown();
	});

/* ====================== SLICK SLIDERS ======================  */
	var url = bonesJS.template_url;
	$('.testimonials-block__slider').slick({
		dots: true,
		infinite: true,
		speed: 1000,
		arrows: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		prevArrow:"<img class='slide-prev' src='"+ url +"/library/images/icons/arrow-white.svg'>",
        nextArrow:"<img class='slide-next' src='"+ url +"/library/images/icons/arrow-white.svg'>",
        responsive: [
			{
	            breakpoint: 768,
	            settings: {
	            	arrows: false,
	            }
	        },
	    ]
});

$('.masthead__bg-slider').slick({
		dots: false,
		infinite: true,
		speed: 1000,
		arrows: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		prevArrow:"<img class='slide-prev' src='"+ url +"/library/images/icons/arrow-white.svg'>",
        nextArrow:"<img class='slide-next' src='"+ url +"/library/images/icons/arrow-white.svg'>",
});

$('.service-gallery__wrap').slick({
		dots: false,
		infinite: true,
		speed: 1000,
		arrows: true,
		dots: false,
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: true,
		rows: 0,
		autoplaySpeed: 3000,
		prevArrow:"<img class='slide-prev' src='"+ url +"/library/images/icons/arrow-blue.svg'>",
        nextArrow:"<img class='slide-next' src='"+ url +"/library/images/icons/arrow-blue.svg'>",
        responsive: [
			{
	            breakpoint: 1200,
	            settings: {
	            	slidesToShow: 3,
	            	dots: true,
	            	arrows: false,
	            }
	        },
	        {
	            breakpoint: 768,
	            settings: {
	            	slidesToShow: 2,
	            	dots: true,
	            	arrows: false,
	            }
	        },
	        {
	            breakpoint: 480,
	            settings: {
	            	slidesToShow: 1,
	            	dots: true,
	            	arrows: false,
	            }
	        },
	    ]
});

/* ====================== GALLERY  ======================  */


	$('[data-fancybox]').fancybox({
        buttons: [
            "close",
            "download",
            "thumbs",
            "share",
        ],
        protect: true,
        loop: true,

    });
});
